/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Pricing_DescInputs */

const en_b2b_pricing_desc = /** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with our Base Operator tier and only pay for what you use. Scale to Sovereign for your own domain and elite branding.`)
};

const es_b2b_pricing_desc = /** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza con nuestro nivel Base Operator y paga solo por lo que usas. Escala a Sovereign para tu propio dominio.`)
};

const fr_b2b_pricing_desc = /** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez avec notre forfait Base Operator et ne payez que ce que vous utilisez. Passez à Sovereign pour votre propre domaine et une image de marque d'élite.`)
};

const de_b2b_pricing_desc = /** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginne mit unserer Base-Operator-Stufe und zahle nur für das, was du nutzt. Skaliere zu Sovereign für deine eigene Domain.`)
};

const id_b2b_pricing_desc = /** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dengan paket Operator Dasar kami dan bayar hanya untuk apa yang Anda gunakan. Skalakan ke Sovereign untuk domain Anda sendiri dan branding elit.`)
};

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const ja_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const zh_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const ar_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const it_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const ru_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const pt_b2b_pricing_desc = en_b2b_pricing_desc;

/** @type {(inputs: B2b_Pricing_DescInputs) => LocalizedString} */
const ko_b2b_pricing_desc = en_b2b_pricing_desc;

/**
* | output |
* | --- |
* | "Start with our Base Operator tier and only pay for what you use. Scale to Sovereign for your own domain and elite branding." |
*
* @param {B2b_Pricing_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_pricing_desc = /** @type {((inputs?: B2b_Pricing_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Pricing_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_pricing_desc(inputs)
	if (locale === "es") return es_b2b_pricing_desc(inputs)
	if (locale === "fr") return fr_b2b_pricing_desc(inputs)
	if (locale === "de") return de_b2b_pricing_desc(inputs)
	if (locale === "ja") return ja_b2b_pricing_desc(inputs)
	if (locale === "zh") return zh_b2b_pricing_desc(inputs)
	if (locale === "ar") return ar_b2b_pricing_desc(inputs)
	if (locale === "id") return id_b2b_pricing_desc(inputs)
	if (locale === "it") return it_b2b_pricing_desc(inputs)
	if (locale === "ru") return ru_b2b_pricing_desc(inputs)
	if (locale === "pt") return pt_b2b_pricing_desc(inputs)
	return ko_b2b_pricing_desc(inputs)
});